<template>
  <div>
    <PageTitle v-bind:title="title" v-bind:admin="false" />

    <div class="row">
      <div class="col-12 col-md-3 mb-5 mb-md-0">
        <img
          src="/images/articles/56329668-2805-4B1D-8606-C6A729A4CE3E.jpeg"
          alt=""
          class="d-block w-100 mx-auto"
        />
      </div>
      <div class="col-12 col-md-9">
        <h2 class="heading--small">
          <router-link :to="{ name: 'article_show', params: { id: 1 } }"
            >FDA одобрило первый препарат для лечения генетически
            детерминированного ожирения</router-link
          >
        </h2>

        <p>
          Управление по санитарному надзору за качеством пищевых продуктов и
          медикаментов США (FDA) одобрило сетмеланотид (Imcivree, Rhythm
          Pharmaceuticals) – средство для контроля веса у взрослых и детей в
          возрасте от 6 лет с ожирением, обусловленного дефицитом
          проопиомеланокортина, пропротеиновой конвертазы субтилизин-кексин типа
          1 или рецептора лептина. Лица с этими редкими генетическими причинами
          тяжелого ожирения имеют при рождении […]
        </p>
        <p>
          <router-link :to="{ name: 'article_show', params: { id: 1 } }"
            >Читать далее</router-link
          >
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-3 mb-5 mb-md-0">        
        <img
          src="/images/articles/1DB92691-EBED-4B58-B31D-095A8608D578.jpeg"
          alt=""
          class="d-block w-100 mx-auto"
        />
      </div>
      <div class="col-12 col-md-9">
        <h2 class="heading--small">
          <router-link :to="{ name: 'article_show', params: { id: 2 } }"
            >Заболеваемость и этиология лекарственных поражений печени в
            континентальном Китае</router-link
          >
        </h2>

        <p>
          Предпосылки и цели Общенациональное ретроспективное исследование
          проведено с целью выяснения частоты и причин лекарственных поражений
          печени (ЛПП) в континентальном Китае. Методы Аккумулированы данные о
          25 927 подтвержденных случаях ЛПП, госпитализированных с 2012 по 2014
          год в 308 медицинских центрах. Проанализированы демографические,
          анамнестические и лабораторные данные, лекарственный анамнез, данные о
          тяжести заболевания и смертности от всех […]
        </p>
        <p>
          <router-link :to="{ name: 'article_show', params: { id: 2 } }"
            >Читать далее</router-link
          >
        </p>
      </div>
    </div>

    <!-- <div>
      <div class="mb-3">
        <img
          src="/images/articles/56329668-2805-4B1D-8606-C6A729A4CE3E.jpeg"
          alt=""
          class="d-block w-50 mx-auto"
        />
      </div>
      <h2 class="heading--small">
        <router-link :to="{ name: 'article_show', params: { id: 1 } }"
          >FDA одобрило первый препарат для лечения генетически
          детерминированного ожирения</router-link
        >
      </h2>

      <p>
        Управление по санитарному надзору за качеством пищевых продуктов и
        медикаментов США (FDA) одобрило сетмеланотид (Imcivree, Rhythm
        Pharmaceuticals) – средство для контроля веса у взрослых и детей в
        возрасте от 6 лет с ожирением, обусловленного дефицитом
        проопиомеланокортина, пропротеиновой конвертазы субтилизин-кексин типа 1
        или рецептора лептина. Лица с этими редкими генетическими причинами
        тяжелого ожирения имеют при рождении […]
      </p>
      <p>
        <router-link :to="{ name: 'article_show', params: { id: 1 } }"
          >Читать далее</router-link
        >
      </p>
    </div>

    <div>
      <h2>
        <router-link :to="{ name: 'article_show', params: { id: 2 } }"
          >Заболеваемость и этиология лекарственных поражений печени в
          континентальном Китае</router-link
        >
      </h2>
      <div>
        <img
          src="/images/articles/1DB92691-EBED-4B58-B31D-095A8608D578.jpeg"
          alt=""
        />
      </div>
      <p>
        Предпосылки и цели Общенациональное ретроспективное исследование
        проведено с целью выяснения частоты и причин лекарственных поражений
        печени (ЛПП) в континентальном Китае. Методы Аккумулированы данные о 25
        927 подтвержденных случаях ЛПП, госпитализированных с 2012 по 2014 год в
        308 медицинских центрах. Проанализированы демографические,
        анамнестические и лабораторные данные, лекарственный анамнез, данные о
        тяжести заболевания и смертности от всех […]
      </p>
      <p>
        <router-link :to="{ name: 'article_show', params: { id: 2 } }"
          >Читать далее</router-link
        >
      </p>
    </div> -->
  </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";

export default {
  data() {
    return {
      title: "Статьи",
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {},
  },
  components: {
    PageTitle,
  },
};
</script>